module.exports = __webpack_public_path__ + "img/writing-fluently.0afaa280.svg";